import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import template from './Button.vue';

type variantType = 'primary' | 'secondary' | 'tetriary';

@Component({
	mixins: [template]
})
export default class Button extends Vue {
	@Prop() to!: any;

	@Prop() loading!: boolean;

	@Prop() disabled!: boolean;

	@Prop() variant!: variantType;

	@Prop() as!: string;

	@Prop() href!: string;

	currentVariant: variantType = 'primary';

	mounted(): void {
		this.currentVariant = this.variant || 'primary';
	}

	@Watch('variant')
	onChange(): void {
		this.currentVariant = this.variant || 'primary';
	}
}
